import { useToast } from '@homeexchange/design';
import { useEffect } from 'react';
var RenderToast = function (_a) {
    var toastText = _a.toastText;
    var showToast = useToast().showToast;
    useEffect(function () {
        showToast('success', toastText);
    }, [toastText]);
    return null;
};
export default RenderToast;
